
var autoSliding = false;
var slideProgressTimeline;

function updateAutoIndicator(slider, indicator) {
    $('.slide-indicator', slider).removeClass('active');
    $('.slide-indicator', slider).eq(indicator.index()).addClass('active');

    $('.slide-indicator', slider).each(function() {
        var slideIndicator = $(this);
        if(slideIndicator.index() < indicator.index()) {
            $('.progress', slideIndicator).css({
                'width': '100%'
            });
        }

        if(slideIndicator.index() >= indicator.index()) {
            $('.progress', slideIndicator).css({
                'width': '0%'
            });
        }
    });

    animateNext(slider);
    
    // $('.current-slide', slider).html(indicator.index() + 1);
    // console.log(indicator.index() + 1);
}

function autoSlideNext(slider) {
    // console.log('next');
    if (autoSliding) {
        return false;
    }

    var active;
    var next;
    autoSliding = true;

    active = $('.slide.active', slider);

    if (active.is(':last-child')) {
        next = $('.slide', slider).first();
    } else {
        next = active.next();
    }

    TweenMax.set(next, {
        x: slider.width()
    });

    TweenMax.to(active, 1, {
        x: - slider.width(),
        // ease: Power0.easeNone
        ease: Power2.easeInOut
    });

    TweenMax.to(next, 1, {
        x: 0,
        // ease: Power0.easeNone,
        ease: Power2.easeInOut,
        onComplete: function () {
            active.removeClass('active');
            next.addClass('active');
            updateAutoIndicator(slider, next);
            autoSliding = false;
        }
    });
}

function animateNext(slider) {
    var active = $('.slide-indicator.active', slider);

    slideProgressTimeline = new TimelineMax({
        paused: true,
        // onStart: function () {
        //     TweenMax.set($('.slide', story), {
        //         'autoAlpha': 0
        //     });

        //     TweenMax.set(slide, {
        //         'autoAlpha': 1
        //     });

        //     TweenMax.set($('.elapsed', slideProgress), {
        //         width: '0%'
        //     });
        // },
        onComplete: function () {
            autoSlideNext(slider);
        }
    });

    slideProgressTimeline.to($('.progress', active), 5, {
        width: '100%',
        ease: Power0.easeNone
    });

    slideProgressTimeline.play();
}

// setup the sliders
function setupAutoSlider(slider) {
    TweenMax.set($('.slide', slider), { x: slider.width() });

    $('.slide', slider)
        .first()
        .addClass('active');
    $('.slide-indicator', slider)
        .first()
        .addClass('active');

    TweenMax.set($('.slide.active', slider), { x: 0 });
}

$('.auto-slider').each(function () {
    var slider = $(this);

    if (slider.hasClass('mobile') && $(window).width() < 720) {
        return true;
    }

    if ($('.slide', slider).length == 1) {
        $('.slider-indicators', slider).remove();

        return false;
    }

    setupAutoSlider(slider);
    animateNext(slider);
});